<!-- manage-subscription-dialog.component.html -->
<h2 mat-dialog-title>Centro assistenza</h2>

<mat-dialog-content>
  <div *ngIf="isLoading" class="text-center mt-3">
    <mat-spinner diameter="30"></mat-spinner>
    <p class="mt-2">Aggiornamento in corso...</p>
  </div>

  <mat-divider></mat-divider>

  <p class="mt-3">Hai bisogno di noi? Contattaci:</p>

  <!-- .izy-fields e' il contenitore che veste i campi con la grammatica BEIZY
       (contorno nero 2px, raggio 16px): lo stesso di tutti gli altri form
       dell'app, cosi' questi campi non restano gli unici col contorno grigio
       sottile di Material. Definito in styles.scss. -->
  <div class="izy-fields">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>La nostra mail</mat-label>
      <input
        matInput
        [value]="helpEmail"
        readonly
        #linkInput>
      <button
        mat-icon-button
        matSuffix
        (click)="copyToClipboard()"
        [attr.aria-label]="'Copia link'">
        <mat-icon>content_copy</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Il nostro numero verde</mat-label>
      <input
        matInput
        [value]="helpNumber"
        readonly
        #linkInput>
      <button
        mat-icon-button
        matSuffix
        (click)="copyNumberToClipboard()"
        [attr.aria-label]="'Copia numero'">
        <mat-icon>content_copy</mat-icon>
      </button>
    </mat-form-field>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- Pillola bianca bordata nera 2px, la stessa dei pulsanti secondari della
       tabella fatture e del dialog di cancellazione: sulla fascia panna e'
       l'uscita neutra. -->
  <button
    mat-stroked-button
    mat-dialog-close
    [disabled]="isLoading"
    class="izy-button-ghost custom-button-border">
    Indietro
  </button>
  <!-- <button 
    mat-raised-button 
    color="primary" 
    (click)="confirm()"
    [disabled]="isLoading || subscriptionForm.invalid"
  >
    <mat-icon>check</mat-icon>
    Salva
  </button> -->
</mat-dialog-actions>
